import React from 'react';

const WidgetDateHeureSvg = ({width = 20, height = 20, couleur = "#A8B0B3"}) => (
    <svg width={width} height={height} viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="date heure">
            <circle id="Ellipse 26" cx="19" cy="19" r="16.5" stroke={couleur} strokeWidth="4"/>
            <path id="Vector 29" d="M19 9.69141V20.2796L24 24.6914" stroke={couleur} strokeWidth="4"/>
        </g>
    </svg>
);

export default WidgetDateHeureSvg;
